module.exports = __webpack_public_path__ + "static/new-video-97ccb0f00bc842b6ba4a9abf4568d5d9.svg";